import { useMemo } from 'react';
import useGetOpenDraft from '@/features/dashboard/bookingChanges/hooks/useGetOpenDraft.ts';
import useGetChangePreview from '@/features/dashboard/bookingChanges/hooks/useGetChangePreview.ts';
import { changePreviewMapper } from '@/features/dashboard/bookingChanges/types/ChangePreviewDto.mapper.ts';
import { ChangePreview } from '@/features/dashboard/bookingChanges/types/ChangePreview.ts';

/**
 * Wpływ otwartej paczki na kwoty rachunku — wejście dla wszystkich ekranów
 * rezerwacji.
 *
 * Rezerwacja bez otwartego szkicu podglądu nie pyta: nie ma czego liczyć,
 * a endpoint i tak odmówiłby paczce zamkniętej. `preview === null` przy
 * niepustym szkicu znaczy więc „kwot nie znamy”, a nie „zero”.
 */
const useChangePreview = (bookingId: string | undefined) => {
  const draftQuery = useGetOpenDraft(bookingId);
  const changeId = draftQuery.data?.id;
  const previewQuery = useGetChangePreview(bookingId, changeId);

  const items = draftQuery.data?.items;
  const preview: ChangePreview | null = useMemo(
    () =>
      previewQuery.data
        ? changePreviewMapper.toChangePreview(previewQuery.data, items ?? [])
        : null,
    [previewQuery.data, items],
  );

  return {
    preview,
    isLoading: !!changeId && previewQuery.isLoading,
    error: previewQuery.error ?? null,
  };
};

export default useChangePreview;
